import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { isChunkLoadError, attemptHardReload } from './utils/chunkReload';
import './styles/index.css';

// Mark a successful boot so the HTML-level fallback in index.html
// (the "Cervica is updating, click to reload" panel) knows React got
// past the initial import. Without this, the fallback fires on every
// real navigation too.
window.__cervicaBootSuccess = true;

// Window-level chunk-error recovery. Catches script tag 404s + unhandled
// import() rejections. We do AT MOST ONE auto-reload — the previous
// 3-attempts-in-60s loop produced the "page flashes then reloads"
// behavior Daniel reported, because the ErrorBoundary's own useEffect
// piled on a second reload while the first was already in-flight.
// After this single attempt, the HTML-level fallback in index.html
// surfaces a "Cervica is updating" panel with a manual reload button.
window.addEventListener('error', (event) => {
  const isScriptTag = event.target && event.target.tagName === 'SCRIPT';
  if (isChunkLoadError(event.message) || isScriptTag) {
    attemptHardReload();
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason || '');
  if (isChunkLoadError(msg)) {
    attemptHardReload();
  }
});

import { queryClient } from './lib/queryClient';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);
